<template>
  <div v-if="isSuperUser">
    <v-row>
      <v-col md="10">
        <v-tabs v-model="activeTab" bg-color="transparent">
          <v-tab :value="0">Þýðingar vefur</v-tab>
          <v-tab :value="1">Skilaboð</v-tab>
          <v-tab :value="2">Loggun</v-tab>
        </v-tabs>

        <v-window v-model="activeTab" class="mt-4">
          <v-window-item :value="0">
            <v-card flat>
              <AdminTranslationsTable />
            </v-card>
          </v-window-item>

          <v-window-item :value="1">
            <v-card flat>
              <Messages />
            </v-card>
          </v-window-item>

          <v-window-item :value="2">
            <v-card flat>
              <Logging />
            </v-card>
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>
  </div>

  <div v-else>
    <h1>Ooops....</h1>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'

import { useAuthStore } from '@/stores/useAuthStore'

// Components
import AdminTranslationsTable from './tables/AdminTranslationsTable.vue'
import Messages from './Messages.vue'
import Logging from './Logging.vue'

const activeTab = ref<number>(0)

const auth = useAuthStore()
const { isSuperUser } = storeToRefs(auth)
</script>
